import { flexRender, getCoreRowModel, useReactTable } from '@tanstack/react-table';
import React from 'react'

const SecurityLogsTable = ({
    securityLogs
}) => {
    const columns = React.useMemo(
        () => [
            {
                header: 'Site',
                accessorKey: 'site.name'
            },
            {
                header: 'Shift',
                accessorKey: 'shift.name',
            },
            {
                header: 'Security Officer',
                accessorKey: 'officer.name'
            },
            {
                header: 'Status',
                accessorKey: 'status'
            },
            {
                header: 'Login Time',
                accessorKey: 'login_at'
            },
            {
                header: 'Logout Time',
                accessorKey: 'logout_at'
            }
        ],
        []
    );

    const table = useReactTable({
        data: securityLogs,
        columns,
        getCoreRowModel: getCoreRowModel()
    });

    if (securityLogs.length === 0){
        return <div className='text-center'>No duty logs found</div>
    }
  return (
    <table className='table table-responsive table-striped'>
        <thead>
            {table.getHeaderGroups().map((headerGroup) => (
                <tr key={headerGroup.id}>
                    {headerGroup.headers.map((header) => (
                        <th key={header.id}>{header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext())}</th>
                    ))}
                </tr>
            ))}
        </thead>
        <tbody>
            {table.getRowModel().rows.map((row) => (
                <tr key={row.id}>
                    {row.getVisibleCells().map((cell) => (
                        <td key={cell.id}>{flexRender(cell.column.columnDef.cell, cell.getContext())}</td>
                    ))}
                </tr>
            ))}
        </tbody>
    </table>
  )
}

export default SecurityLogsTable